/**
 * @description Event types for window object
 * @author Stan Gletski
 */
export enum WindowEvent {

	/**
	 * @description The beforeunload event is fired when the window, the document and its resources
	 * are about to be unloaded. The document is still visible and the event is still cancelable at this point.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event}
	 */
	BEFORE_UNLOAD = 'beforeunload',

	/**
	 * @description The unload event is fired when the document or a child resource is being unloaded.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event}
	 */
	UNLOAD = 'unload',

	/**
	 * @description Browser event fired by using bak and forward buttons
	 * @type {WindowEvent.POP_STATE}
	 */
	POP_STATE = 'popstate',

	/**
	 * @description Fired when the document view (window) is resized.
	 * @type {WindowEvent.RESIZE}
	 */
	RESIZE = 'resize',

	/**
	 * @description Fired when the window receives focus.
	 * @type {WindowEvent.FOCUS}
	 */
	FOCUS = 'focus',

	/**
	 * @description Fired when the browser regains network connectivity.
	 * @type {WindowEvent.ONLINE}
	 */
	ONLINE = 'online',

	/**
	 * @description Fired when the browser loses network connectivity.
	 * @type {WindowEvent.OFFLINE}
	 */
	OFFLINE = 'offline',

	/**
	 * @description Fired when a JS promise rejects with no handler. Used by the avia error
	 * handler to suppress avia's internal rejection noise.
	 * @type {WindowEvent.UNHANDLED_REJECTION}
	 */
	UNHANDLED_REJECTION = 'unhandledrejection'
}